import React from 'react';

export function Slot() { return <></>; }